import * as React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Store } from "redux";
import { IChildrenProp } from "./Types";

interface IProps extends IChildrenProp {
  store: Store;
}

/**
 * Responsible for rendering the IntlProvider component
 */
const StateAndRouterProvider: React.FC<IProps> = (props: IProps) => {

  return (
    <Provider store={ props.store }>
      <BrowserRouter basename="/">
        {props.children}
      </BrowserRouter>
    </Provider>
  );
};

export { StateAndRouterProvider };
